import { Box, Stack, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import {
  StyledPinnedColumns,
  StyledCell,
  StyledGrid,
  StyledTriangle,
} from "./styles";
import dayjs from "dayjs";
import ScheduleTableMonthHeader from "./ScheduleTableMonthHeader";
import { useGetScheduleOrders } from "../../hooks";

const ScheduleTableHeader = ({ defaultLocation = 1 }) => {
  const { data } = useGetScheduleOrders({ defaultLocation });
  const period = data?.period || {};
  const { days = [], months = [] } = period;

  const sx = {
    position: "sticky",
    backgroundColor: "hubColors.white",
    zIndex: 200,
    "& .MuiTableCell-root": {
      borderBottom: "1px solid",
    },
  };

  const curr = dayjs().format("MM-DD-YYYY");
  return (
    <TableHead sx={sx}>
      <TableRow sx={sx}>
        <StyledPinnedColumns />
        <ScheduleTableMonthHeader months={months} />
      </TableRow>
      <TableRow sx={sx}>
        <StyledPinnedColumns>
          <StyledGrid>
            <span></span>
            <Typography variant="captionGrey">Customer</Typography>
            <Typography variant="captionGrey">Work Order</Typography>
          </StyledGrid>
        </StyledPinnedColumns>
        {days?.map(({ id, label }) => {
          const [day, date] = label?.split(",");
          const isCurr = id === curr;
          return (
            <StyledCell
              key={id}
              sx={{
                paddingY: "7px !important",
              }}
            >
              <Stack
                gap="5px"
                sx={{
                  span: {
                    textAlign: "center",
                    lineHeight: "12px",
                    fontWeight: isCurr ? 900 : 500,
                    ...(isCurr && { color: "hubColors.fontWhite" }),
                    zIndex: 51,
                  },
                }}
              >
                <Typography variant="caption" sx={{ color: "hubColors.grey" }}>
                  {day}
                </Typography>
                <Typography variant="caption">{date}</Typography>
                {isCurr && (
                  <>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        backgroundColor: "hubColors.mainFocus",
                        borderRadius: "5px",
                        zIndex: 50,
                        top: 0,
                        left: 0,
                      }}
                    />
                    <StyledTriangle />
                  </>
                )}
              </Stack>
            </StyledCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default ScheduleTableHeader;
